import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/banner-noTask.svg'


const _withScopeId = n => (_pushScopeId("data-v-2828d8a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "noTask is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "banner",
  src: _imports_0,
  alt: "Banner de Tarefas não realizadas"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "noTask-text" }, "Parece que você não está sendo muito produtivo hoje! 😥", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}